import { Menu } from "@headlessui/react";
import { MinusCircleIcon } from "@heroicons/react/24/outline";
import api from "@src/api/api";
import { showBlockUserModal } from "@src/state/blockUserModal/actions";
import { useAppSelector } from "@src/state/hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import tw from "twin.macro";

type Props = {
  userId: string;
  blocked?: boolean;
  keys?: string[];
};

const BlockUserDropdownButton = (props: Props) => {
  const { userId, blocked, keys = [] } = props;
  const queryClient = useQueryClient();
  const { user } = useAppSelector(state => state.user);
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const block = useMutation([`block-${userId}`], {
    mutationFn: async () => {
      const res = await api.get(`/api/v1/users/${userId}/block`);
      return res.data;
    },
    onSuccess: () => {
      keys.forEach(key => {
        queryClient.invalidateQueries({ queryKey: [key] });
      });
    },
    onError: () => {
      alert("Failed");
    },
  });

  const unblock = useMutation([`unblock-${userId}`], {
    mutationFn: async () => {
      const res = await api.get(`/api/v1/users/${userId}/unblock`);
      return res.data;
    },
    onSuccess: () => {
      keys.forEach(key => {
        queryClient.invalidateQueries({ queryKey: [key] });
      });
    },
    onError: () => {
      alert("Failed");
    },
  });

  if (user?.id === userId) return <></>;

  return (
    <Menu.Item>
      {({ active }) => (
        <button
          onClick={e => {
            if (blocked) {
              unblock.mutate();
            } else {
              dispatch(showBlockUserModal(userId));
            }
            e.stopPropagation();
          }}
          type="submit"
          css={[
            active ? tw`bg-gray-100 text-gray-900` : tw`text-gray-700`,
            tw`block w-full px-4 py-2 text-left text-sm inline-flex items-center justify-between`,
          ]}
        >
          {blocked ? `${t("buttons.unblock")}` : `${t("buttons.block")}`}
          <MinusCircleIcon className="size-4" />
        </button>
      )}
    </Menu.Item>
  );
};

export default BlockUserDropdownButton;
